import { UUIDLike } from '../types/uuid-like';

export type { UUIDLike };

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Returns `true` (and narrows `value` to {@link UUIDLike}) when `value` is a
 * string matching the UUID shape `xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx`.
 *
 * Shape-only — no RFC 4122 version or variant enforcement, so backend-produced
 * UUIDs like `b4c3a2f1-0e9d-4c8b-7a6f-5e4d3c2b1a10` are accepted.
 *
 * @example
 * isUUIDLike('b4c3a2f1-0e9d-4c8b-7a6f-5e4d3c2b1a10'); // true
 * isUUIDLike('550e8400-e29b-41d4-a716-446655440000'); // true
 * isUUIDLike('not-a-uuid');                            // false
 * isUUIDLike(42);                                      // false
 */
export function isUUIDLike(value: unknown): value is UUIDLike {
  return typeof value === 'string' && UUID_REGEX.test(value);
}
